import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SingleSessions from "./index";
import { useContext } from "react";
import { UserContext } from "App";

const SingleSessionsPage = () => {
  const User = useContext(UserContext);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SingleSessions CurrentUser={User} />
    </DashboardLayout>
  );
};

export default SingleSessionsPage;
